<template>
  <div class="relative flex items-center px-2">
    <button
      class="notification-btn relative flex items-center justify-center transition-colors border rounded-full h-10 w-10 border-semantic-inverse-container-lowest bg-semantic-primary-variant-light text-semantic-primary-on-light hover:bg-semantic-inverse-container-lowest hover:text-semantic-inverse-primary"
      @click="handleNotificationClick"
    >
      <ClientOnly>
        <span
          v-if="notificationCount"
          class="flex absolute right-0 top-0.5 z-1 h-2 w-2 rounded-full bg-red-500"
        >
          <span
            class="absolute inline-flex w-full h-full bg-red-500 rounded-full opacity-75 -z-1 animate-ping"
          ></span>
        </span>
      </ClientOnly>
      <svg
        class="fill-current"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.75 2.29248C10.75 1.87827 10.4143 1.54248 10 1.54248C9.58583 1.54248 9.25004 1.87827 9.25004 2.29248V2.83613C6.08266 3.20733 3.62504 5.9004 3.62504 9.16748V14.4591H3.33337C2.91916 14.4591 2.58337 14.7949 2.58337 15.2091C2.58337 15.6234 2.91916 15.9591 3.33337 15.9591H4.37504H15.625H16.6667C17.0809 15.9591 17.4167 15.6234 17.4167 15.2091C17.4167 14.7949 17.0809 14.4591 16.6667 14.4591H16.375V9.16748C16.375 5.9004 13.9174 3.20733 10.75 2.83613V2.29248ZM14.875 14.4591V9.16748C14.875 6.47509 12.6924 4.29248 10 4.29248C7.30765 4.29248 5.12504 6.47509 5.12504 9.16748V14.4591H14.875ZM8.00004 17.7085C8.00004 18.1228 8.33583 18.4585 8.75004 18.4585H11.25C11.6643 18.4585 12 18.1228 12 17.7085C12 17.2943 11.6643 16.9585 11.25 16.9585H8.75004C8.33583 16.9585 8.00004 17.2943 8.00004 17.7085Z"
          fill=""
        />
      </svg>
    </button>
  </div>
</template>

<script setup>
defineOptions({
  name: 'MoleculesNavNotification'
})

const brazeNotificationStore = useBrazeNotificationStore()
const { notificationCount } = storeToRefs(brazeNotificationStore) // { notificationCount: 25 }
const { $bus, $tracking } = useNuxtApp()
const $route = useRoute()
const { notification, data_ab_card_id } = $route.query

defineProps({
  version: {
    type: String,
    default: 'new'
  }
})

// Handle notifications on icon click
const handleNotificationClick = event => {
  $tracking.click(event, '', { 
    elementId: 'notification-toggle-btn',
    elementInnerText: 'notification-bell-icon'
  })
  $bus.emit('toggleNotifications', {})
}

onMounted(() => {
  brazeNotificationStore.initializeBraze()
  brazeNotificationStore.pollContentCards()

  autoOpenNotification()
})

onUnmounted(() => {
  brazeNotificationStore.clearPolling()
})

function autoOpenNotification (){
  if(notification !== 'true')
    return
  
  nextTick(function (){
    setTimeout(function (){
      $bus.emit('toggleNotifications', {})

      if(!data_ab_card_id)
        return

      setTimeout(function (){
        scrollToCard(data_ab_card_id)
      }, 500)
    }, 2000)
  })
}

const scrollToCard = cardId => {
  // Wait for Braze content cards to be fully rendered
  const checkAndScroll = () => {
    const feedElement = document.getElementById('feed')
    const targetCard = feedElement?.querySelector(`[data-ab-card-id="${cardId}"]`) ||
        feedElement?.querySelector(`#${cardId}`)

    if (targetCard) {
      targetCard.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
      return true
    }
    return false
  }

  // Try immediately
  if (checkAndScroll()) return

  // If not found, wait and retry (Braze might still be rendering)
  const maxRetries = 10
  let retryCount = 0

  const retryInterval = setInterval(() => {
    if (checkAndScroll() || retryCount >= maxRetries) {
      clearInterval(retryInterval)
    }
    retryCount++
  }, 100)
}
</script>
